import React from 'react';
import {connect} from 'react-redux';
import {IntlProvider} from 'react-intl';

export function mapStateToProps(state) {
    const {i18n: {translations, locale}, config: {site}} = state;

    return {
        messages: translations,
        currencyDisplay: site.currencyDisplay || 'symbol',
        locale
    };
}

export function mergeProps(state, dispatchProps, props) {
    return {
        ...props,
        ...state
    };
}

export const Component = ({locale, messages, currencyDisplay, ...props}) => (
    <IntlProvider
        {...props}
        messages={messages}
        locale={locale.replace(/^([^_]+)_([^_]+)(:?_.+)?$/g, '$1-$2')}
        formats={{number: {price: {currencyDisplay}}}}
    />
);

export const IntlProviderConnected = connect(mapStateToProps, null, mergeProps)(
    Component
);
